import React, { useState, useEffect } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useApp } from "../../contexts/AppContext";
import { ExpiryAlertsModal } from "../common/ExpiryAlertsModal";

export const AppLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showExpiryModal, setShowExpiryModal] = useState(false);
  const { notifications, isAdmin, expiringContracts } = useApp();

  useEffect(() => {
    if (!isAdmin || !expiringContracts?.length) return;

    const lastShownKey = "expiryModalLastShown";
    const lastShown = localStorage.getItem(lastShownKey);
    const now = Date.now();
    const oneDayMs = 24 * 60 * 60 * 1000;

    if (!lastShown || (now - parseInt(lastShown)) > oneDayMs) {
      setShowExpiryModal(true);
      localStorage.setItem(lastShownKey, now.toString());
    }
  }, [isAdmin, expiringContracts]);

  return (
    <div className="flex h-screen bg-white overflow-hidden">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <main className="flex-1 overflow-y-auto px-8 py-6 bg-white">
          <div className="page-enter">{children}</div>
        </main>
      </div>

      {/* Notification toasts */}
      <div className="fixed bottom-6 right-6 flex flex-col gap-2 z-[9999]">
        {notifications.map(n => (
          <div
            key={n.id}
            className={`max-w-sm p-4 rounded-lg border text-sm font-medium shadow-lg animate-slideIn ${
              n.type === "error"
                ? "bg-red-50 border-red-300 text-red-800"
                : n.type === "success"
                ? "bg-green-50 border-green-300 text-green-800"
                : "bg-blue-50 border-gray-200 text-gray-800"
            }`}
          >
            {n.msg}
          </div>
        ))}
      </div>

      <style>{`@keyframes slideIn{from{opacity:0;transform:translateX(24px)}to{opacity:1;transform:translateX(0)}} .animate-slideIn{animation:slideIn 0.3s ease}`}</style>

      {showExpiryModal && expiringContracts?.length > 0 && (
        <ExpiryAlertsModal contracts={expiringContracts} onClose={() => setShowExpiryModal(false)} />
      )}
    </div>
  );
};
